import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const AdvertisementAdd: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthApi();
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' } | null>(null);
  const [formData, setFormData] = useState({
    title: '',
    type: 'sell',
    category: '',
    description: '',
    price: '',
    province: '',
    contact_phone: ''
  });

  const showToast = (message: string, type: 'success' | 'error') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  // ── بررسی احراز هویت ──────────────────────────────────
  if (!isAuthenticated || !user) {
    return (
      <div style={{ direction: 'rtl', padding: '50px', textAlign: 'center' }}>
        <h2>⚠️ لطفاً ابتدا وارد شوید</h2>
        <Link to="/login" style={{ color: '#2e7d32' }}>رفتن به صفحه ورود</Link>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.title || !formData.description || !formData.contact_phone) {
      showToast('عنوان، توضیحات و شماره تماس الزامی است', 'error');
      return;
    }

    if (!formData.contact_phone.match(/^09[0-9]{9}$/)) {
      showToast('شماره تماس نامعتبر است (مثال: 09123456789)', 'error');
      return;
    }

    setSaving(true);

    try {
      const payload = {
        title: formData.title,
        type: formData.type,
        category: formData.category,
        description: formData.description,
        price: formData.price ? parseFloat(formData.price) : null,
        province: formData.province,
        contact_phone: formData.contact_phone
      };

      console.log('📤 ارسال آگهی:', payload);

      const response = await fetch('https://fellfell.ir/api/advertisements.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      console.log('📨 پاسخ:', data);

      if (data.success) {
        showToast('✅ آگهی با موفقیت ثبت شد و در انتظار تایید است', 'success');
        setTimeout(() => {
          navigate('/advertisements');
        }, 2000);
      } else {
        showToast('❌ خطا در ثبت آگهی: ' + (data.message || 'خطای نامشخص'), 'error');
      }
    } catch (err: any) {
      console.error('❌ خطا:', err);
      showToast('❌ خطا در ارتباط با سرور: ' + err.message, 'error');
    }

    setSaving(false);
  };

  return (
    <div style={{ direction: 'rtl', padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      {toast && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          padding: '14px 28px',
          borderRadius: '12px',
          fontSize: '15px',
          zIndex: 9999,
          background: toast.type === 'success' ? '#2e7d32' : '#c62828',
          color: '#fff',
          boxShadow: '0 6px 25px rgba(0,0,0,0.25)',
          animation: 'slideDown 0.3s ease-out'
        }}>
          {toast.message}
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
          <h1 style={{ color: '#1e3a1e', fontSize: '24px' }}>📢 ثبت آگهی جدید</h1>
          <Link to="/advertisements" style={{ color: '#2e7d32', textDecoration: 'none' }}>
            ← بازگشت به لیست آگهی‌ها
          </Link>
        </div>

        <form onSubmit={handleSubmit}>
          {/* عنوان */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              عنوان آگهی <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <input
              type="text"
              value={formData.title}
              onChange={e => setFormData({ ...formData, title: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: فروش گوجه فرنگی گلخانه‌ای"
              required
            />
          </div>

          {/* نوع آگهی */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              نوع آگهی <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <select
              value={formData.type}
              onChange={e => setFormData({ ...formData, type: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              required
            >
              <option value="sell">🟢 فروش</option>
              <option value="buy">🔵 خرید</option>
              <option value="request">🟡 درخواست</option>
              <option value="cooperation">🟣 همکاری</option>
            </select>
          </div>

          {/* دسته‌بندی */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              دسته‌بندی
            </label>
            <input
              type="text"
              value={formData.category}
              onChange={e => setFormData({ ...formData, category: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: محصولات کشاورزی، دام، تجهیزات"
            />
          </div>

          {/* قیمت */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              قیمت (تومان)
            </label>
            <input
              type="number"
              value={formData.price}
              onChange={e => setFormData({ ...formData, price: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: 250000 (در صورت توافقی خالی بگذارید)"
            />
          </div>

          {/* استان */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              استان
            </label>
            <input
              type="text"
              value={formData.province}
              onChange={e => setFormData({ ...formData, province: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px' }}
              placeholder="مثلاً: تهران، اصفهان، فارس"
            />
          </div>

          {/* شماره تماس */}
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              شماره تماس <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <input
              type="tel"
              value={formData.contact_phone}
              onChange={e => setFormData({ ...formData, contact_phone: e.target.value })}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', direction: 'ltr' }}
              placeholder="09123456789"
              required
            />
          </div>

          {/* توضیحات */}
          <div style={{ marginBottom: '22px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px' }}>
              توضیحات <span style={{ color: '#d32f2f' }}>*</span>
            </label>
            <textarea
              value={formData.description}
              onChange={e => setFormData({ ...formData, description: e.target.value })}
              rows={5}
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '2px solid #ddd', fontSize: '15px', resize: 'vertical' }}
              placeholder="توضیحات کامل آگهی را وارد کنید..."
              required
            />
          </div>

          {/* دکمه‌ها */}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '20px' }}>
            <Link to="/advertisements" style={{
              padding: '12px 24px',
              background: '#e0e0e0',
              color: '#333',
              textDecoration: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '500'
            }}>
              انصراف
            </Link>
            <button
              type="submit"
              disabled={saving}
              style={{
                padding: '12px 30px',
                background: '#2e7d32',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer',
                opacity: saving ? 0.6 : 1
              }}
            >
              {saving ? '⏳ در حال ثبت...' : '📢 ثبت آگهی'}
            </button>
          </div>
        </form>

        <div style={{ marginTop: '20px', padding: '15px', background: '#f5faf5', borderRadius: '10px', fontSize: '13px', color: '#666' }}>
          <strong>📌 نکته:</strong> آگهی شما پس از ثبت، در انتظار تایید قرار می‌گیرد و پس از تایید در سایت نمایش داده می‌شود.
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AdvertisementAdd;